import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useFiling } from "../../contexts/FilingContext";
import { Heading, Subheading } from "../../design/heading";
import LoadingView from "../../components/LoadingView";
import EditFilingButton from "./components/EditFilingButton";
import DeleteFilingButton from "./components/DeleteFilingButton";
import ErrorView from "../../components/ErrorView";
import Breadcrumbs from "../../components/Breadcrumbs";
import moment from "moment";
import DownloadFilingButton from "./components/DownloadFilingButton";
import FilingDetailSectionList from "./components/FilingDetailSectionList/FilingDetailSectionList";
import { Navbar, NavbarItem } from "../../design/navbar";
import FilingDetailExhibitList from "./components/FilingDetailExhibitList/FilingDetailExhibitList";
import { Text } from "../../design/text";

const FilingDetailPage: React.FC = () => {
  const { filingId } = useParams<{ filingId: string }>();
  const { filing, setSelectedFiling, error, loading, setFiling } = useFiling();
  const [state, setState] = React.useState<"Sections" | "Exhibits">("Sections");

  useEffect(() => {
    if (!filingId) return;
    setSelectedFiling(filingId);
  }, [filingId]);

  if (loading.details) return <LoadingView title="Loading Filing..." />;
  if (error.details) return <ErrorView error={error.details} />;
  if (!filing) return <ErrorView error={new Error("Filing not found")} />;

  return (
    <div className="flex flex-col gap-6">
      <Breadcrumbs
        items={[
          { label: "Filings", href: "/filings" },
          { label: filing.name, href: `/filing/${filing.name}` },
        ]}
      />

      <div className="flex flex-col gap-6 lg:flex-row">
        <div className="flex flex-col w-full gap-6">
          <div className="w-full">
            <div className="flex items-center justify-between">
              <div>
                <Heading>{filing.name}</Heading>
                {filing.filingDate && (
                  <div className="flex items-center gap-2">
                    <Subheading>Filed on:</Subheading>{" "}
                    <Text>
                      {moment(filing.filingDate).format("MMM D, YYYY")}
                    </Text>
                  </div>
                )}
                {filing.description && <Text>{filing.description}</Text>}
              </div>
              <div className="flex gap-2">
                <DownloadFilingButton filing={filing} />
                <EditFilingButton filing={filing} />
                <DeleteFilingButton filingId={filing._id} />
              </div>
            </div>
            <p className="mt-1 text-sm text-muted-foreground">
              {filing.description}
            </p>
          </div>
          <Navbar className="mb-4">
            {(["Sections", "Exhibits"] as const).map((item) => (
              <NavbarItem
                key={item}
                className="text-base"
                onClick={() => setState(item)}
                current={state === item}
              >
                {item}
              </NavbarItem>
            ))}
          </Navbar>
          {state === "Sections" && <FilingDetailSectionList />}
          {state === "Exhibits" && <FilingDetailExhibitList />}
        </div>
      </div>
    </div>
  );
};

export default FilingDetailPage;
